import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import styles from "./style.module.scss";
import CustomButton from "shared/components/customButton";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface DistinguishConfirmationProps {
  open: boolean;
  handleClose: any;
  loader: boolean;
  text: string;
  handleClick: any;
  heading?: string;
}

export default function DistinguishConfirmation({
  open,
  handleClose,
  loader,
  handleClick,
  text,
  heading = "Distinguish Author",
}: DistinguishConfirmationProps) {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className={`${styles.content} ${styles.flexGrid}`}>
          <Icons.CrossIcon
            className={styles.crossIcon}
            onClick={() => handleClose()}
          />

          {heading && (
            <div className={styles.heading}>
              {heading}
            </div>
          )}
          <div className={styles.contentLabel}>
            {text}
          </div>
          <div className={styles.buttonsContainer}>
            <CustomButton
              text="Cancel"
              buttonStyle={styles.cancelBtn}
              handleClick={handleClose}
            />
            <CustomButton
              text="Confirm"
              handleClick={handleClick}
              loader={loader}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
